// Vue Account Settings
const AccountProfile = () =>
  import(
    /* webpackChunkName: "accountprofile" */ "../components/account/AccountSettings.vue"
  );
const AccountGeneral = () =>
  import(
    /* webpackChunkName: "accountgeneral" */ "../components/account/AccountGeneral.vue"
  );
const AccountUsers = () =>
  import(
    /* webpackChunkName: "accountusers" */ "../components/account/AccountUsers.vue"
  );
const EditUser = () =>
  import(
    /* webpackChunkName: "userprofile" */ "../components/account/AccountUserProfile.vue"
  );
const AccountBilling = () =>
  import(
    /* webpackChunkName: "accountbilling" */ "../components/account/AccountBilling.vue"
  );
const InvoiceDetails = () =>
  import(
    /* webpackChunkName: "invoicedetails" */ "../components/account/AccountBillingInvoiceTransactions.vue"
  );
const AccountLocations = () =>
  import(
    /* webpackChunkName: "accountlocations" */ "../components/account/AccountLocations.vue"
  );
const EditLocation = () =>
  import(
    /* webpackChunkName: "editlocation" */ "../components/account/AccountLocationsEdit.vue"
  );
const AccountBrand = () =>
  import(
    /* webpackChunkName: "editbrand" */ "../components/account/AccountBrand.vue"
  );
const AccountDepartments = () =>
  import(
    /* webpackChunkName: "accountdepartments" */ "../components/account/AccountDepartments.vue"
  );
const AccountIntegrations = () =>
  import(
    /* webpackChunkName: "accountintegrations" */ "../components/account/integrations/AccountIntegrations.vue"
  );
const AccountIntegrationEdit = () =>
  import(
    /* webpackChunkName: "accountintegration" */ "../components/account/integrations/AccountIntegrationsEdit.vue"
  );
const AccountIntegrationSearch = () =>
  import(
    /* webpackChunkName: "accountintegrationsearch" */ "../components/account/integrations/AccountIntegrationsSearch.vue"
  );
const PricingAndFees = () =>
  import(
    /* webpackChunkName: "pricingandfees" */ "../components/company_information/PricingAndFees.vue"
  );
const LegalPolicies = () =>
  import(
    /* webpackChunkName: "legalpolicies" */ "../components/company_information/LegalPolicies.vue"
  );

// Integration Callback Uris
const CallbackEmploymentHero = () =>
  import(
    /* webpackChunkName: "callbackemploymenthero" */ "../components/account/integrations/callbacks/CallbackEmploymentHero.vue"
  );

// Vue Login and Registration
import AuthView from "../components/auth/AuthApp.vue";
import UserLogin from "../components/auth/login/UserLogin.vue";
import UserLogout from "../components/auth/login/UserLogout.vue";
import SplashScreen from "../components/auth/login/SplashScreen.vue";

const AcceptTerms = () =>
  import(
    /* webpackChunkName: "accountterms" */ "../components/auth/registration/AcceptTerms.vue"
  );
const Registration = () =>
  import(
    /* webpackChunkName: "registration" */ "../components/auth/registration/AppRegistration.vue"
  );
const ErrorPage = () =>
  import(
    /* webpackChunkName: "404error" */ "../components/auth/login/404Error.vue"
  );

// Newsfeed
const NewsfeedView = () =>
  import(
    /* webpackChunkName: "newsfeed" */ "../components/features/newsfeed/NewsfeedView.vue"
  );

// Events
const EventsView = () =>
  import(
    /* webpackChunkName: "events" */ "../components/features/events/EventsView.vue"
  );
const EventsDetails = () =>
  import(
    /* webpackChunkName: "eventsdetail" */ "../components/features/events/EventsDetails.vue"
  );

// Content Management
const ContentEditor = () =>
  import(
    /* webpackChunkName: "contenteditor" */ "../components/features/content/ContentEditor.vue"
  );
const VideoEditor = () =>
  import(
    /* webpackChunkName: "videoeditor" */ "../components/features/content/VideoEditor.vue"
  );
const TopicView = () =>
  import(
    /* webpackChunkName: "topicview" */ "../components/features/content/TopicView.vue"
  );
const TopicEditor = () =>
  import(
    /* webpackChunkName: "topiceditor" */ "../components/features/content/TopicEditor.vue"
  );
const ContentView = () =>
  import(
    /* webpackChunkName: "contentview" */ "../components/features/content/user/ContentView.vue"
  );

// Challenges
const ChallengesView = () =>
  import(
    /* webpackChunkName: "challenges" */ "../components/features/challenges/ChallengesView.vue"
  );
const ChallengeView = () =>
  import(
    /* webpackChunkName: "challenge" */ "../components/features/challenges/ChallengeView.vue"
  );
const ChallengeEditor = () =>
  import(
    /* webpackChunkName: "challengeeditor" */ "../components/features/challenges/ChallengeEditor.vue"
  );
const ChallengeFeed = () =>
  import(
    /* webpackChunkName: "challengeeditor" */ "../components/features/challenges/user/ChallengesFeed.vue"
  );
const ChallengeUserView = () =>
  import(
    /* webpackChunkName: "challengeeditor" */ "../components/features/challenges/user/ChallengeView.vue"
  );

// Recruitment
const MarketplaceView = () =>
  import(
    /* webpackChunkName: "marketplace" */ "../components/features/recruitment/customer/MarketplaceView.vue"
  );
const Onboarding = () =>
  import(
    /* webpackChunkName: "onboarding" */ "../components/features/onboarding/OnboardingView.vue"
  );
const ProspectView = () =>
  import(
    /* webpackChunkName: "prospectview" */ "../components/features/onboarding/ProspectView.vue"
  );
const JobPosts = () =>
  import(
    /* webpackChunkName: "jobposts" */ "../components/features/recruitment/customer/JobPosts.vue"
  );
const Clients = () =>
  import(
    /* webpackChunkName: "clients" */ "../components/features/recruitment/customer/MarketplaceClients.vue"
  );
const RecruitmentSettings = () =>
  import(
    /* webpackChunkName: "recruitmentsettings" */ "../components/features/recruitment/customer/RecruitmentSettings.vue"
  );
const MarketplaceSearch = () =>
  import(
    /* webpackChunkName: "marketplacesearch" */ "../components/features/recruitment/customer/MarketplaceSearch.vue"
  );

const JobPostEditor = () =>
  import(
    /* webpackChunkName: "jobposteditor" */ "../components/features/recruitment/customer/JobPostEditor.vue"
  );
const JobPostView = () =>
  import(
    /* webpackChunkName: "jobpostview" */ "../components/features/recruitment/customer/JobPostView.vue"
  );
const ClientView = () =>
  import(
    /* webpackChunkName: "clientview" */ "../components/features/recruitment/customer/ClientView.vue"
  );
const UserMarketplace = () =>
  import(
    /* webpackChunkName: "usermarketplace" */ "../components/features/recruitment/user/UserMarketplace.vue"
  );

// Training
const TrainingView = () =>
  import(
    /* webpackChunkName: "training" */ "../components/features/training/TrainingView.vue"
  );
const TrainingActivities = () =>
  import(
    /* webpackChunkName: "trainingactivities" */ "../components/features/training/activities/TrainingActivities.vue"
  );
const TrainingModules = () =>
  import(
    /* webpackChunkName: "trainingmodules" */ "../components/features/training/TrainingModules.vue"
  );
const TrainingModuleView = () =>
  import(
    /* webpackChunkName: "trainingmodule" */ "../components/features/training/modules/TrainingModuleView.vue"
  );
const TrainingModuleCreate = () =>
  import(
    /* webpackChunkName: "trainingmodulecreate" */ "../components/features/training/modules/TrainingModuleCreate.vue"
  );
const TrainingPeople = () =>
  import(
    /* webpackChunkName: "trainingpeople" */ "../components/features/training/people/TrainingPeople.vue"
  );
const LearningContentWrittenEditor = () =>
  import(
    /* webpackChunkName: "learningcontentwritten" */ "../components/features/training/learning/LearningContentWritten.vue"
  );
const LearningContentVideoEditor = () =>
  import(
    /* webpackChunkName: "learningcontentvideo" */ "../components/features/training/learning/LearningContentVideo.vue"
  );
const CompetencyTest = () =>
  import(
    /* webpackChunkName: "competencytests" */ "../components/features/training/competency/CompetencyTestView.vue"
  );
const CoursesView = () =>
  import(
    /* webpackChunkName: "courses" */ "../components/features/training/user/TrainingView.vue"
  );

// Rewards
const RewardsView = () =>
  import(
    /* webpackChunkName: "rewards" */ "../components/features/rewards/RewardsView.vue"
  );
const RewardItems = () =>
  import(
    /* webpackChunkName: "rewarditems" */ "../components/features/rewards/RewardsItems.vue"
  );
const RewardClaims = () =>
  import(
    /* webpackChunkName: "rewarditems" */ "../components/features/rewards/RewardsClaims.vue"
  );
const RewardPeople = () =>
  import(
    /* webpackChunkName: "rewarditems" */ "../components/features/rewards/RewardsPeople.vue"
  );

// Goal Posts
const GoalPostsView = () =>
  import(
    /* webpackChunkName: "goalposts" */ "../components/features/goal_posts/GoalPostsView.vue"
  );

// Forms
const FormsView = () =>
  import(
    /* webpackChunkName: "forms" */ "../components/features/forms/FormsView.vue"
  );
const FormEditor = () =>
  import(
    /* webpackChunkName: "form-editor" */ "../components/features/forms/FormEditor.vue"
  );

// Admin
const AdminCompanyAccounts = () =>
  import(
    /* webpackChunkName: "adminaccounts" */ "../components/admin/accounts/AdminCompanyAccounts.vue"
  );
const AdminCompanyAccountsView = () =>
  import(
    /* webpackChunkName: "adminaccountsview" */ "../components/admin/accounts/AdminCompanyAccountsView.vue"
  );
const AdminUserAccounts = () =>
  import(
    /* webpackChunkName: "adminusers" */ "../components/admin/accounts/AdminUserAccounts.vue"
  );
const AdminUserAccountsView = () =>
  import(
    /* webpackChunkName: "adminuser" */ "../components/admin/accounts/AdminUserAccountsView.vue"
  );

// VueX
import store from "../store/index.js";

// Vue Router
import { createRouter, createWebHistory } from "vue-router";

//Auth0
import { authGuard } from "@auth0/auth0-vue";

// The Marketplace is a per-company feature (FR-39), and Onboarding rides on
// the same toggle: it is where a recruiter's prospects become users, so it has
// nothing to do for a company without recruitment. The side menu hides both and
// the backend refuses the Marketplace endpoints with a 403 when the toggle is
// off, so the routes are guarded too — otherwise a direct link or a bookmark
// still opens a page that can only fail.
const recruitmentGuard = (_to, _from, next) => {
  if (store.getters["userData/companyFeatures"]?.enableRecruitment === true) {
    next();
  } else {
    next({ name: "newsfeed" });
  }
};

// The general user's job marketplace: recruitment on, the Marketplace not
// switched off, and a general user (company staff use Marketplace above).
const userMarketplaceGuard = (_to, _from, next) => {
  const allowed =
    store.getters["userData/userType"] == "general" &&
    store.getters["userData/companyFeatures"]?.enableRecruitment === true &&
    store.getters["userData/companyRecruitment"]?.marketplaceEnabled !== false;

  next(allowed ? undefined : { name: "newsfeed" });
};

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // Business Routes
    {
      name: "splash",
      path: "/",
      component: SplashScreen,
      meta: {
        auth: true,
      },
    },
    {
      name: "newsfeed",
      path: "/newsfeed",
      component: NewsfeedView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "events",
      path: "/events",
      component: EventsView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "event",
      path: "/event/:id",
      component: EventsDetails,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "forms",
      path: "/forms",
      component: FormsView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "form-editor",
      path: "/form-editor/:id",
      component: FormEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "goal-posts",
      path: "/goal-posts",
      component: GoalPostsView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "content-editor",
      path: "/content-editor/:id",
      component: ContentEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "video-editor",
      path: "/video-editor/:id",
      component: VideoEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "content",
      path: "/content",
      component: ContentView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "topics",
      path: "/topics",
      component: TopicView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "topic-editor",
      path: "/topic-editor/:id",
      component: TopicEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "challenges",
      path: "/challenges",
      component: ChallengesView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "onboarding",
      path: "/onboarding",
      component: Onboarding,
      beforeEnter: recruitmentGuard,
      meta: {
        auth: false,
        topLevel: "onboarding",
        requiresAuth: true,
      },
    },
    {
      name: "prospect-view",
      path: "/prospect-view/:id",
      component: ProspectView,
      beforeEnter: recruitmentGuard,
      meta: {
        auth: false,
        topLevel: "onboarding",
        requiresAuth: true,
      },
    },
    {
      name: "marketplace",
      path: "/marketplace",
      component: MarketplaceView,
      redirect: { name: "marketplace-job-posts" },
      beforeEnter: recruitmentGuard,
      meta: {
        auth: false,
        topLevel: "marketplace",
        requiresAuth: true,
      },
      children: [
        {
          name: "marketplace-search",
          path: "search",
          component: MarketplaceSearch,
        },
        {
          name: "marketplace-job-posts",
          path: "job-posts",
          component: JobPosts,
        },
        {
          name: "marketplace-clients",
          path: "clients",
          component: Clients,
        },
        {
          name: "marketplace-settings",
          path: "settings",
          component: RecruitmentSettings,
        },
      ],
    },
    {
      name: "job-post-editor",
      // No id creates a job; an id edits that one.
      path: "/job-post-editor/:id?",
      component: JobPostEditor,
      beforeEnter: recruitmentGuard,
      meta: {
        auth: false,
        topLevel: "marketplace",
        requiresAuth: true,
      },
    },
    {
      name: "user",
      path: "/user-profile/:id",
      component: EditUser,
      meta: {
        auth: false,
        topLevel: "account",
        requiresAuth: true,
      },
    },
    {
      name: "user-marketplace",
      path: "/marketplace-jobs",
      component: UserMarketplace,
      beforeEnter: userMarketplaceGuard,
      meta: {
        auth: false,
        topLevel: "user-marketplace",
        requiresAuth: true,
      },
    },
    {
      name: "job-post-view",
      path: "/job-post-view/:id",
      component: JobPostView,
      beforeEnter: recruitmentGuard,
      meta: {
        auth: false,
        topLevel: "marketplace",
        requiresAuth: true,
      },
    },
    {
      name: "client-view",
      path: "/client-view/:id",
      component: ClientView,
      beforeEnter: recruitmentGuard,
      meta: {
        auth: false,
        topLevel: "marketplace",
        requiresAuth: true,
      },
    },
    {
      name: "challenge-view",
      path: "/challenge-view/:id",
      component: ChallengeView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "challenge-editor",
      path: "/challenge-editor/:id",
      component: ChallengeEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "challenges-feed",
      path: "/challenges-feed",
      component: ChallengeFeed,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "challenge-item",
      path: "/challenge-item/:id",
      component: ChallengeUserView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "training",
      path: "/training",
      component: TrainingView,
      meta: {
        auth: false,
        topLevel: "training",
        requiresAuth: true,
      },
      children: [
        {
          name: "training-activities",
          path: "activities",
          component: TrainingActivities,
        },
        {
          name: "training-modules",
          path: "modules",
          component: TrainingModules,
        },
        { name: "training-people", path: "people", component: TrainingPeople },
      ],
    },
    {
      name: "training-module",
      path: "/training-module/:id",
      component: TrainingModuleView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "courses",
      path: "/courses",
      component: CoursesView,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "create-training-module",
      path: "/create-training-module",
      component: TrainingModuleCreate,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "learning-content-editor",
      path: "/learning-content-editor/:id",
      component: LearningContentWrittenEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "learning-video-editor",
      path: "/learning-video-editor/:id",
      component: LearningContentVideoEditor,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "competency-test",
      path: "/competency-test/:id",
      component: CompetencyTest,
      meta: {
        auth: false,
        requiresAuth: true,
      },
    },
    {
      name: "rewards",
      path: "/rewards",
      component: RewardsView,
      meta: {
        auth: false,
        topLevel: "rewards",
        requiresAuth: true,
      },
      children: [
        { name: "reward-items", path: "reward-items", component: RewardItems },
        {
          name: "reward-claims",
          path: "reward-claims",
          component: RewardClaims,
        },
        {
          name: "reward-people",
          path: "reward-people",
          component: RewardPeople,
        },
      ],
    },
    {
      name: "account",
      path: "/account",
      component: AccountProfile,
      meta: {
        auth: false,
        topLevel: "account",
        requiresAuth: true,
      },
      children: [
        { name: "account-general", path: "general", component: AccountGeneral },
        { name: "account-users", path: "users", component: AccountUsers },
        { name: "brand", path: "brand", component: AccountBrand },
        {
          name: "account-locations",
          path: "locations",
          component: AccountLocations,
        },
        { name: "location", path: "location/:id", component: EditLocation },
        {
          name: "account-departments",
          path: "departments",
          component: AccountDepartments,
        },
        {
          name: "billing-and-payments",
          path: "billing-and-payments",
          component: AccountBilling,
        },
        { name: "invoice", path: "invoice/:id", component: InvoiceDetails },
        {
          name: "account-integrations",
          path: "integrations",
          component: AccountIntegrations,
        },
        {
          name: "integration",
          path: "integration/:id",
          component: AccountIntegrationEdit,
        },
        {
          name: "search-integrations",
          path: "search-integrations/:type",
          component: AccountIntegrationSearch,
        },
        {
          name: "pricing-and-fees",
          path: "pricing-and-fees",
          component: PricingAndFees,
        },
        {
          name: "legal-and-policies",
          path: "legal-and-policies",
          component: LegalPolicies,
        },
        // Integration Callbacks
        {
          name: "eh-callback",
          path: "eh-callback",
          component: CallbackEmploymentHero,
        },
      ],
    },
    // Admin Routes
    {
      name: "admin-accounts",
      path: "/admin-accounts",
      component: AdminCompanyAccounts,
      meta: {
        auth: false,
        topLevel: "accounts",
        requiresAuth: true,
      },
    },
    {
      name: "admin-account",
      path: "/admin-account/:id",
      component: AdminCompanyAccountsView,
      meta: {
        auth: false,
        topLevel: "accounts",
        requiresAuth: true,
      },
    },
    {
      name: "admin-users",
      path: "/admin-users",
      component: AdminUserAccounts,
      meta: {
        auth: false,
        topLevel: "accounts",
        requiresAuth: true,
      },
    },
    {
      name: "admin-user",
      path: "/admin-user/:id",
      component: AdminUserAccountsView,
      meta: {
        auth: false,
        topLevel: "accounts",
        requiresAuth: true,
      },
    },
    // Other Routes
    {
      name: "auth",
      path: "/auth",
      component: AuthView,
      meta: { auth: true },
      redirect: { name: "login" },
      children: [
        { path: "/:notFound(.*)", component: ErrorPage }, // Page Not Found
      ],
    },
    {
      name: "registration",
      path: "/registration",
      meta: {
        auth: true,
        requiresAuth: true,
      },
      component: Registration,
      beforeEnter: (_to, _from, next) => {
        // Checks if user has completed registration
        if (store.getters["userData/registrationComplete"]) {
          next({ name: "topics" });
        } else {
          next();
        }
      },
    },
    {
      name: "accept-terms",
      path: "/terms",
      meta: {
        auth: true,
      },
      component: AcceptTerms,
    },
    {
      name: "callback",
      path: "/callback",
      component: UserLogin,
      meta: {
        auth: true,
        requiresAuth: true,
      },
    },
    {
      name: "logout",
      path: "/logout",
      component: UserLogout,
      meta: {
        auth: true,
        requiresAuth: true,
      },
    },
    {
      path: "/:pathMatch(.*)",
      redirect: { name: "splash" },
      name: "catchAll",
    },
  ],
});

// Checks route requires Authorisation and if the user is currently Authenticated
router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth) {
    authGuard(to, from);
    next();
  } else {
    next();
  }
});

router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
